import { render } from "./Domotica.vue?vue&type=template&id=8b76e362&scoped=true"
import script from "./Domotica.vue?vue&type=script&lang=js"
export * from "./Domotica.vue?vue&type=script&lang=js"

import "./Domotica.vue?vue&type=style&index=0&id=8b76e362&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b76e362"]])

export default __exports__